/* My Bike: one saved bike (browser localStorage) used by the header bar, the picker dialog,
   the product page fit line and the homepage finder. Model list: assets/nep-hd-models.json
   ({ "2021": [{ m: "Road Glide", c: "FLTRX", f: "Touring" }, ...] }), loaded on demand.
   The fit line only says "Fits" when family, year range and any named model in the product's
   fitment text all agree; anything uncertain asks the rider to confirm with a tech. */
(function () {
  if (window.NepBike) return;
  var KEY = "nep_my_bike";
  var models = null;

  function get() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "null");
    } catch (e) {
      return null;
    }
  }
  function emit(b) {
    document.dispatchEvent(new CustomEvent("nep:bike", { detail: b }));
  }
  function set(b) {
    try {
      localStorage.setItem(KEY, JSON.stringify(b));
    } catch (e) {}
    emit(b);
  }
  function clear() {
    try {
      localStorage.removeItem(KEY);
    } catch (e) {}
    emit(null);
  }
  function label(b) {
    return b ? b.year + " " + b.model : "";
  }
  function modelsUrl() {
    var el = document.querySelector("[data-nep-models]");
    return el ? el.getAttribute("data-nep-models") : null;
  }
  function load() {
    if (models) return Promise.resolve(models);
    var url = modelsUrl();
    if (!url) return Promise.reject(new Error("no model list"));
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (j) {
        models = j;
        return j;
      });
  }
  function hub(b) {
    if (!b) return "/collections/all";
    var y = parseInt(b.year, 10);
    switch (b.family) {
      case "Touring":
        return "/pages/touring-parts";
      case "Softail":
        return y >= 2018 ? "/pages/m8-softail-parts" : "/pages/softail-parts";
      case "Dyna":
        return "/pages/dyna-all-parts";
      case "Sportster":
        return "/pages/sportster-parts";
      case "FXR":
        return "/pages/fxr-parts";
      case "Trike":
        return "/pages/trike-parts";
      default:
        return "/search?type=product&q=" + encodeURIComponent(b.model);
    }
  }

  /* ---------- selects (shared by the dialog and the homepage finder) ---------- */
  function fillYears(sel, data, keep) {
    var years = Object.keys(data).sort(function (a, b) {
      return b - a;
    });
    sel.innerHTML =
      '<option value="">Year</option>' +
      years
        .map(function (y) {
          return (
            '<option value="' +
            y +
            '"' +
            (String(keep) === y ? " selected" : "") +
            ">" +
            y +
            "</option>"
          );
        })
        .join("");
  }
  function fillModels(sel, data, year, keep) {
    var list = data[year] || [];
    var groups = {};
    list.forEach(function (e) {
      (groups[e.f] = groups[e.f] || []).push(e);
    });
    var html =
      '<option value="">' +
      (year ? "Model" : "Pick a year first") +
      "</option>";
    Object.keys(groups).forEach(function (f) {
      html +=
        '<optgroup label="' +
        f +
        '">' +
        groups[f]
          .map(function (e) {
            var v = JSON.stringify({ m: e.m, c: e.c, f: e.f }).replace(
              /"/g,
              "&quot;",
            );
            return (
              '<option value="' +
              v +
              '"' +
              (keep && keep === e.m ? " selected" : "") +
              ">" +
              e.m +
              "</option>"
            );
          })
          .join("") +
        "</optgroup>";
    });
    sel.innerHTML = html;
    sel.disabled = !year;
  }
  function readBike(yearSel, modelSel) {
    if (!yearSel.value || !modelSel.value) return null;
    var e = JSON.parse(modelSel.value);
    return { year: yearSel.value, model: e.m, code: e.c, family: e.f };
  }
  function bindPair(yearSel, modelSel, onChange) {
    var b = get();
    return load().then(function (data) {
      fillYears(yearSel, data, b && b.year);
      fillModels(modelSel, data, yearSel.value, b && b.model);
      yearSel.addEventListener("change", function () {
        fillModels(modelSel, data, yearSel.value);
        onChange && onChange();
      });
      modelSel.addEventListener("change", function () {
        onChange && onChange();
      });
      onChange && onChange();
    });
  }

  /* ---------- picker dialog ---------- */
  function openPicker() {
    var d = document.getElementById("nep-bike-dialog");
    if (!d) return;
    var ys = d.querySelector("[data-nep-year]"),
      ms = d.querySelector("[data-nep-model]");
    var save = d.querySelector("[data-nep-save]");
    if (!d.dataset.bound) {
      d.dataset.bound = "1";
      bindPair(ys, ms, function () {
        save.disabled = !readBike(ys, ms);
      }).catch(function () {});
      save.addEventListener("click", function () {
        var b = readBike(ys, ms);
        if (b) {
          set(b);
          close();
        }
      });
      d.querySelector("[data-nep-clear]").addEventListener(
        "click",
        function () {
          clear();
          close();
        },
      );
      d.querySelectorAll("[data-nep-close]").forEach(function (x) {
        x.addEventListener("click", close);
      });
      d.addEventListener("click", function (e) {
        if (e.target === d) close();
      });
    }
    if (typeof d.showModal === "function") d.showModal();
    else d.setAttribute("open", "");
    function close() {
      if (typeof d.close === "function") d.close();
      else d.removeAttribute("open");
    }
  }

  /* ---------- header bar ---------- */
  function renderBar(b) {
    document.querySelectorAll("[data-nep-bike-bar]").forEach(function (bar) {
      var lbl = bar.querySelector("[data-nep-bike-label]");
      var shop = bar.querySelector("[data-nep-bike-shop]");
      if (lbl) lbl.textContent = b ? label(b) : "Add your bike";
      if (shop) {
        shop.hidden = !b;
        if (b) shop.href = hub(b);
      }
      bar.classList.toggle("has-bike", !!b);
    });
  }

  /* ---------- product fit line ---------- */
  var FAMILY_WORDS = [
    [
      "Touring",
      /\b(touring|bagger|flh\w*|flt\w*|road glide|street glide|road king|electra glide|ultra (classic|limited))\b/,
    ],
    ["Trike", /\b(trike|tri glide|freewheeler)\b/],
    [
      "Softail",
      /\b(softail|m8 softail|fat bob|fat boy|breakout|sport glide|heritage|street bob|low ?rider s|low ?rider st|slim)\b/,
    ],
    ["Dyna", /\bdyna\b/],
    ["Sportster", /\b(sportster|xl\d*)\b/],
    ["FXR", /\bfxr\w*\b/],
    ["Pan America", /\bpan america\b/],
  ];
  var MODEL_WORDS = [
    "road glide",
    "street glide",
    "road king",
    "electra glide",
    "ultra limited",
    "low rider st",
    "low rider s",
    "lowrider st",
    "fat bob",
    "fat boy",
    "breakout",
    "sport glide",
    "heritage",
    "street bob",
    "tri glide",
    "freewheeler",
  ];

  function yearsOf(t) {
    var spans = [];
    var re =
        /((?:19|20)\d{2})(?:\.5)?\s*(?:-|–|to)\s*((?:19|20)\d{2}(?:\.5)?|present|current|newer|up)/g,
      m;
    while ((m = re.exec(t))) {
      var hi = /^\d/.test(m[2]) ? parseFloat(m[2]) : 9999;
      spans.push([parseFloat(m[1]), hi]);
    }
    re =
      /((?:19|20)\d{2})(?:\.5)?\s*(?:\+|and up|& up|and newer|& newer|and later)/g;
    while ((m = re.exec(t))) spans.push([parseFloat(m[1]), 9999]);
    re =
      /((?:19|20)\d{2})(?:\.5)?\s*(?:& earlier|and earlier|and older|& older)/g;
    while ((m = re.exec(t))) spans.push([0, parseFloat(m[1])]);
    if (!spans.length) {
      re = /\b((?:19|20)\d{2})\b/g;
      while ((m = re.exec(t))) spans.push([parseFloat(m[1]), parseFloat(m[1])]);
    }
    if (/\b(m8|m-eight|milwaukee[- ]eight)\b/.test(t)) spans.push([2017, 9999]);
    if (/\btwin cam\b/.test(t) && !spans.length) spans.push([1999, 2017]);
    return spans;
  }
  function judge(text, b) {
    var t = (text || "").toLowerCase().replace(/®|™/g, "");
    if (!t.trim()) return "unknown";
    var y = parseFloat(b.year),
      model = (b.model || "").toLowerCase();
    var spans = yearsOf(t);
    var yearOK = !spans.length
      ? null
      : spans.some(function (s) {
          return y >= s[0] && y <= s[1];
        });
    if (/\ball (harley[- ]davidson )?models\b/.test(t))
      return yearOK === false ? "no" : yearOK ? "fits" : "unknown";
    var fams = FAMILY_WORDS.filter(function (fw) {
      return fw[1].test(t);
    }).map(function (fw) {
      return fw[0];
    });
    if (!fams.length) return "unknown";
    if (fams.indexOf(b.family) === -1) return "no";
    if (yearOK === false) return "no";
    var named = MODEL_WORDS.filter(function (w) {
      return t.indexOf(w) !== -1;
    });
    if (
      named.length &&
      !named.some(function (w) {
        return (
          model
            .replace("lowrider", "low rider")
            .indexOf(w.replace("lowrider", "low rider")) !== -1
        );
      })
    )
      return "unknown";
    return yearOK ? "fits" : "unknown";
  }
  function judgeRules(rules, b) {
    if (!rules || !rules.length) return null;
    if (rules[0].none) return "hidden";
    if (rules.some(function (r) { return r.f === "*"; })) return "fits";
    var y = parseFloat(b.year), model = (b.model || "").toLowerCase().replace("lowrider", "low rider");
    var mine = rules.filter(function (r) { return r.f === b.family; });
    if (!mine.length) return "no";
    var family = false, other = false;
    for (var i = 0; i < mine.length; i++) {
      var r = mine[i];
      var yearOK = r.y0 == null ? null : y >= r.y0 && y <= r.y1;
      var models = r.m || [];
      var modelOK = !models.length || models.some(function (w) { return model.indexOf(w) !== -1; });
      if (yearOK === true && modelOK) return "fits";
      if (yearOK === null) family = true;
      else if (yearOK && !modelOK) other = true;
    }
    if (family) return "family";
    return other ? "unknown" : "no";
  }
  function renderFit(b) {
    var src = document.querySelector("[data-product-fit]");
    if (!src) return;
    var text = src.getAttribute("data-fitment") || "";
    var title = document.querySelector("h1.b-main-title");
    var lines = Array.prototype.slice.call(document.querySelectorAll("[data-nep-fitline]"));
    if (!lines.length && title) {
      var made = document.createElement("p");
      made.setAttribute("data-nep-fitline", "");
      made.className = "nep-fitline";
      title.insertAdjacentElement("afterend", made);
      lines = [made];
    }
    var dropLines = function () { lines.forEach(function (l) { l.remove(); }); };
    var html, state;
    var rules0 = null;
    try { rules0 = JSON.parse(src.getAttribute("data-fit-rules") || "null"); } catch (e) { rules0 = null; }
    if (rules0 && rules0[0] && rules0[0].none) {
      dropLines();
      src.innerHTML = "";
      return;
    }
    if (!b) {
      state = "none";
      html =
        '<button type="button" class="nep-fitline__btn" data-nep-bike-open>Add your bike to check fitment</button>';
    } else {
      var rules = null;
      try { rules = JSON.parse(src.getAttribute("data-fit-rules") || "null"); } catch (e) { rules = null; }
      state = judgeRules(rules, b) || judge(text, b);
      var who = label(b).replace(/</g, "&lt;");
      var change =
        ' <button type="button" class="nep-fitline__btn nep-fitline__change" data-nep-bike-open>Change bike</button>';
      var famName = b.family;
      if (state === "hidden") {
        dropLines();
        src.innerHTML = "";
        return;
      }
      if (state === "family")
        html =
          "Made for " + famName + " models. Call or chat with us on the site and a tech can confirm it fits your " +
          who +
          "." +
          change;
      else if (state === "fits")
        html =
          '<span class="nep-fitline__icon" aria-hidden="true"></span>Fits your ' +
          who +
          "." +
          change;
      else if (state === "no")
        html =
          "Listed for other models. Call or chat with us on the site and a tech can confirm it with you for your " +
          who +
          "." +
          change;
      else
        html =
          "Call or chat with us on the site and a tech can confirm it fits your " +
          who +
          "." +
          change;
    }
    lines.concat([src]).forEach(function (el) {
      if (!el) return;
      el.innerHTML = html;
      el.setAttribute("data-state", state);
    });
  }

  /* ---------- collection "fits my bike" filter ---------- */
  var FIT_ONLY = "nep_fit_only";
  function fitOnly() {
    try { return localStorage.getItem(FIT_ONLY) === "1"; } catch (e) { return false; }
  }
  var applying = false;
  function applyFitFilter() {
    var boxes = document.querySelectorAll("[data-nep-fitfilter]");
    if (!boxes.length) return;
    applying = true;
    var b = get();
    var on = !!b && fitOnly();
    var cards = document.querySelectorAll(".product-grid [data-product-handle], #product-grid [data-product-handle]");
    var shown = 0, total = 0;
    cards.forEach(function (card) {
      var item = card.closest(".grid__item") || card;
      total++;
      var hide = false;
      if (on) {
        var rules = null;
        try { rules = JSON.parse(card.getAttribute("data-fit-rules") || "null"); } catch (e) { rules = null; }
        hide = judgeRules(rules, b) === "no";
      }
      item.style.display = hide ? "none" : "";
      if (!hide) shown++;
    });
    boxes.forEach(function (box) {
      var input = box.querySelector("[data-nep-fitonly]");
      var lbl = box.querySelector("[data-nep-fitfilter-label]");
      var btn = box.querySelector("[data-nep-bike-open]");
      var count = box.querySelector("[data-nep-fitfilter-count]");
      input.disabled = !b;
      input.checked = on;
      lbl.textContent = b ? "Only show parts that fit my " + label(b) : "Add your bike to see parts that fit";
      btn.textContent = b ? "Change bike" : "Add your bike";
      count.textContent = on ? "Showing " + shown + " of " + total + " on this page" : "";
      if (!input.dataset.bound) {
        input.dataset.bound = "1";
        input.addEventListener("change", function () {
          try { localStorage.setItem(FIT_ONLY, input.checked ? "1" : "0"); } catch (e) {}
          applyFitFilter();
        });
      }
    });
    applying = false;
  }
  if (window.MutationObserver) {
    var fitTimer;
    new MutationObserver(function () {
      if (applying) return;
      clearTimeout(fitTimer);
      fitTimer = setTimeout(applyFitFilter, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- homepage finder ---------- */
  function bindFinders() {
    document.querySelectorAll("[data-nep-finder]").forEach(function (f) {
      if (f.dataset.bound) return;
      f.dataset.bound = "1";
      var ys = f.querySelector("[data-nep-year]"),
        ms = f.querySelector("[data-nep-model]"),
        go = f.querySelector("[data-nep-go]");
      bindPair(ys, ms, function () {
        go.disabled = !readBike(ys, ms);
      }).catch(function () {});
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var b = readBike(ys, ms);
        if (!b) return;
        set(b);
        window.location.href = hub(b);
      });
    });
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-nep-bike-open]")) {
      e.preventDefault();
      openPicker();
    }
  });
  document.addEventListener("nep:bike", function (e) {
    renderBar(e.detail);
    renderFit(e.detail);
    applyFitFilter();
  });
  function init() {
    var b = get();
    renderBar(b);
    renderFit(b);
    bindFinders();
    applyFitFilter();
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);

  window.NepBike = {
    get: get,
    set: set,
    clear: clear,
    load: load,
    hub: hub,
    label: label,
    open: openPicker,
    judge: judge,
    judgeRules: judgeRules,
  };
})();
